<template>
  <v-container fluid class="ma-0 pa-0 fill-height">
    <v-row no-gutters class="fill-height">
      <v-col class="pt-0" lg="4" xl="4" md="5" sm="12" cols="12">
        <div class="secondary px-4 lighten-2 login-form__container">
          <v-card color="primary" class="pa-10 elevation-4 rounded-xl login-card d-flex flex-column">
            <v-card-title class="login-card__title">Login</v-card-title>
            <error-alert dismissible :message.sync="errors" />
            <v-card-text>
              <v-text-field
                v-model="form.email"
                class="login-card__field rounded-lg"
                single-line
                outlined
                type="text"
                dense
                color="secondary"
                background-color="white"
                :error-messages="fieldErrors[0]"
                label="E-mail"
                @keypress.enter="login"
              ></v-text-field>
              <v-text-field
                v-model="form.password"
                outlined
                class="login-card__field rounded-lg"
                dense
                color="secondary"
                single-line
                :error-messages="fieldErrors[1]"
                background-color="white"
                type="password"
                label="Password"
                @keypress.enter="login"
              ></v-text-field>
            </v-card-text>
            <v-card-actions class="login-card-actions">
              <v-btn width="160px" color="accent darken-3" class="white--text" @click="login">login</v-btn>
            </v-card-actions>
          </v-card>
          <img class="layer" src="/images/Vector.svg" />
          <img class="layer" src="/images/Vector-1.svg" />
          <img class="layer" src="/images/Vector-2.svg" />
        </div>
      </v-col>
      <v-col cols="0" md="7" lg="8" xl="8" sm="0" class="hidden-sm-and-down">
        <div class="login-form__info-text">
          <div class="login-form__info-text-overlay">
            <span class="white--text text-h4 text-center font-weight-black text-uppercase"
              >Welcome to Active Metals Search Portal!
            </span>
            <br />
            <span class="white--text text-center text-h5 text-uppercase">Please Login to continue</span>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "@/store/modules/user";
import { extractErrorMessageAxios } from "@/httpClient";

export default {
  data() {
    return {
      form: {
        email: "",
        password: "",
      },
      position: {
        lat: "",
        long: "",
      },
    };
  },
  watch: {
    form: {
      deep: true,
      handler: function(val) {
        this.clearErrors();
      },
    },
  },
  methods: {
    ...mapActions({
      signIn: "login",
      clearErrors: "clearFieldErrors",
      fetchUser: "fetchUser",
    }),
    async login() {
      try {
        await this.signIn(this.form);
        const authedUser = await this.fetchUser();
        if (authedUser) {
          this.$store.dispatch("user/setGuest", { value: "isNotGuest" });
          this.setUserLocation();
          this.$router.push({ name: "search" });
        }
      } catch (e) {
        this.$store.commit("SET_ERRORS", extractErrorMessageAxios(e));
      }
    },
    async setUserLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(await this.saveUserLocation, this.handleGeoLocationErrors, {
          enableHighAccuracy: true,
        });
      }
    },
    async saveUserLocation(position) {
      try {
        const { latitude, longitude } = position.coords;
        await window.axios.post(`/api/user/location/${this.user.id}`, {
          coords: `${latitude},${longitude}`,
        });
      } catch (e) {
        this.handleGeoLocationErrors(e);
      }
    },
    buildContext(e) {
      return { email: this.email, user: this.user, error: e.message };
    },
    async handleGeoLocationErrors(err) {
      try {
        await window.axios.post(`/api/user/location/${this.user.id}`);
      } catch (e) {
        const context = this.buildContext(e)
        await window.axios.post('/api/log', {level: 'info', context, statement: 'Unable to save user location!' });
      }
    },
  },
  computed: {
    ...mapState(["errors", "fieldErrors", "user"]),
  },
};
</script>
<style scoped>
.login-card--field {
  width: 150px;
}
.login-card-actions {
  flex-direction: column;
}
.login-card--actions__button {
  width: 160px;
}
.login-card-footer {
  margin: auto auto 0 auto;
  display: flex;
}
.login-card-footer__link {
  font-size: 10px;
}
.layer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: min-content;
  max-width: 20em;
  z-index: 0;
}
.login-form__container {
  display: grid;
  z-index: 1;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-content: center;
}
.login-card {
  min-width: 300px;
  min-height: 440px;
  width: 350px;
  height: 500px;
  z-index: 1;
  max-width: 350px;
  max-height: 500px;
}
.login-form__info-text {
  height: 100%;
  background: url("/images/truck.jpeg");
  background-repeat: no-repeat;
  background-size: cover;
}
.login-form__info-text-overlay {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  opacity: 1;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}
@media screen and (max-width: 320px) {
}
</style>
